<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Invoice</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="addInvoiceForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12 class="mb-4">
            <v-autocomplete
              label="Company *"
              v-model="newItem.company_id"
              :items="companyTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>

          <v-flex xs12 class="mb-0">
            <v-layout row>
              <v-flex xs6 class="mr-1">
                <v-autocomplete
                  label="Client *"
                  v-model="newItem.client_id"
                  :items="clientTV"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  outline
                  label="Client Project name *"
                  required
                  v-model="newItem.client_project_name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 class="mb-0">
            <v-layout row>
              <v-flex xs6 class="mr-1">
                <v-autocomplete
                  label="Coordinator"
                  v-model="newItem.coordinator_id"
                  :items="coordinatorTV"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  @change="onCoordinatorChange"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  outline
                  label="Commission %"
                  v-model="newItem.coordinator_commission_parcent"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout row>
            <v-flex xs6 class="pr-1">
              <v-menu
                v-model="paymentDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="newItem.invoice_date"
                    label="Date *"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newItem.invoice_date"
                  @input="paymentDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                outline
                label="Invoice Number *"
                required
                v-model="newItem.invoice_number"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-flex xs12>
            <v-text-field
              outline
              label="Title *"
              required
              v-model="newItem.title"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex> -->

          <v-layout row>
            <v-flex xs6>
              <v-text-field
                outline
                label="Amount *"
                type="number"
                required
                v-model="newItem.amount"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="pl-1">
              <v-text-field
                outline
                label="VAT % *"
                type="number"
                required
                v-model="newItem.vat_parcent"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-textarea v-model="newItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { PAYMENT_METHODS } from "../../mdsir/const";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

const NEW_ITEM_DEFAULT = {
  company_id: "",
  client_id: "",
  coordinator_id: "",
  invoice_date: new Date().toISOString().substr(0, 10),
  invoice_number: "",
  vat_parcent: 15,
  amount: "",
  notes: "",
  client_project_name: "",
  coordinator_commission_parcent: "",
};
export default {
  props: ["clientTV", "companyTV", "coordinatorTV", "coordinators"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: NEW_ITEM_DEFAULT,
      paymentDateMenu: false,
      checkDateMenu: false,
    };
  },
  computed: {},
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addInvoiceForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addInvoiceForm.reset();
    },
    resetValidation() {
      this.$refs.addInvoiceForm.resetValidation();
    },
    clearForm() {
      this.newItem = {
        company_id: "",
        client_id: "",
        coordinator_id: "",
        invoice_date: new Date().toISOString().substr(0, 10),
        invoice_number: "",
        vat_parcent: 15,
        amount: "",
        notes: "",
        client_project_name: "",
        coordinator_commission_parcent: "",
      };
    },
    newItemDo() {
      if (this.$refs.addInvoiceForm.validate()) {
        this.actionButtonClicked = true;
        this.post(
          "/invoice",
          removeEmptyProps(this.newItem, ["check_date", "account_head_id"])
        ).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    onCoordinatorChange(coordinator_id) {
      const SC = this.coordinators.find((r) => r.id == coordinator_id);
      this.newItem.coordinator_commission_parcent = SC.commission_percent;
    },
  },
  mounted() {},
  created() {
    this.PAYMENT_METHODS = PAYMENT_METHODS;
  },
};
</script>
